import MonitoringLayout from "./MonitoringLayout";
import { thirdPartyNotificationRoutes } from "./modules/thirdPartyNotification/routes";

export const monitoringRoutes = {
  path: "monitorings",
  component: MonitoringLayout,
  children: [...thirdPartyNotificationRoutes()]
};



// WEBPACK FOOTER //
// ./src/features/monitoring/routes.js